module.exports = "/_next/static/images/bsi-4a6aacfd7b7d3c684d69d552498df95d.png";